import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../objects/CharacterOxxo";
import { CameraController } from "../../componets3D/CameraController";
import { MouseEvents } from "../../componets3D/MouseEvents";
import { Cards, KeyboardModel, Lata, MapOxxoTopicFive, MonitorIntroTopicFive, Phone } from "../objects/Topics";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { PinPad } from "../objects/Topics/TopicTwo/PinPad";

export class SceneTopicFive extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.light()
		this.create();
		this.listeners()
		this.renderAnimations();
	}

	create() {
		this.map = new MapOxxoTopicFive(this.loadingManager);
		this.add(this.map);
		this.add(this.characterSelected)

		this.monitor = new MonitorIntroTopicFive(this.loadingManager);
		this.monitor.visible = false
		this.add(this.monitor);

		this.keyboard = new KeyboardModel(this.loadingManager)
		this.keyboard.visible = false
		this.add(this.keyboard)

		this.pinPad = new PinPad(this.loadingManager);
		this.pinPad.visible = false
		this.add(this.pinPad)

		this.cards = new Cards(this.loadingManager);
		this.cards.visible = false
		this.add(this.cards)

		this.phone = new Phone(this.loadingManager);
		this.phone.visible = false
		this.add(this.phone)

		this.lata1 = new Lata(this.loadingManager);
		this.lata1.visible = false
		this.add(this.lata1)

		this.lata2 = new Lata(this.loadingManager);
		this.lata2.visible = false
		this.add(this.lata2)

		this.lata3 = new Lata(this.loadingManager);
		this.lata3.visible = false
		this.add(this.lata3)
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	characterMoveInitScene() {
		this.characterSelected.onAnimateSaludo();
		this.characterSelected.visible = true;
		this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
		this.characterSelected.rotation.set(0, -1.5145, 0);
	}


	resetActOne() {
		// this.characterSelected.visible = false
	}

	sceneActivityOneState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema6.topic5.actScene, (step = "") => {
			switch (step) {
				case "move_desk":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {

					});
					this.characterSelected.visible = true
					break;
				case "move_close_desk":
					this.camera.moveCameraToPoint(new Vector3(-11.9553, -0.5964, -2.0764), 1, new Vector3(-11.04, -0.628, -1.673), () => {
						this.camera.control.minDistance = 0.6;
						this.camera.control.maxDistance = 2;
					});
					this.cards.Puntos.visible = false
					this.cards.Ticket.visible = false
					this.cards.visible = true
					this.cards.position.set(-11, -0.7, -1.23)
					this.cards.rotation.set(0, -2, 0)
					break;
				case "move_client_1": // en recepcion
					this.cards.Puntos.visible = true
					this.cards.Ticket.visible = true
					this.cards.visible = false
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-12.3798, -0.6119, 3.8756), 1, new Vector3(-12.049, -0.671, 3.379), () => {
					});
					break;
				default:
					this.resetActOne()
					break;
			}
		})
	}

	sceneActivityTwoState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema6.topic5.actScene, (step = "") => {
			switch (step) {
				case "hide_init":
					this.cards.Spin.visible = true
					this.cards.Ticket.visible = true
					this.cards.visible = false
					break;
				case "move_phone":
					this.characterSelected.visible = true
					this.phone.selectTexture(this.phone.namesTextures.topic5)
					this.phone.visible = true
					this.phone.position.set(-11.09, -0.86, -1.45)
					this.phone.scale.set(3, 3, 3)
					this.phone.rotation.set(-0.54, -1.2, -0.21)
					break;
				case "move_spin":
					this.phone.visible = false
					this.cards.Puntos.visible = false
					this.cards.Ticket.visible = false
					this.cards.visible = true
					this.cards.position.set(-11, -0.7, -1.23)
					break;
				case "move_desk":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					});
					this.cards.Puntos.visible = true
					this.cards.Ticket.visible = true
					this.cards.visible = false
					break;
				case "move_products":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-11.97, -0.1378, 0.138), 1, new Vector3(-10.584, -1.579, 0.145), () => {
						// this.camera.control.enableRotate = true;
						// this.camera.control.enablePan = true;
					});
					this.pinPad.visible = true
					this.pinPad.position.set(-10.85, -0.97, 0.078)
					this.keyboard.visible = true
					this.keyboard.position.set(-11.3, -0.99, -0.8)
					this.lata1.visible = true
					this.lata1.position.set(-11.3, -0.92, 0.065)
					this.lata2.visible = true
					this.lata2.position.set(-11.3, -0.92, 0.335)
					this.lata3.visible = true
					this.lata3.position.set(-11.3, -0.81, 0.2)
					break;
				case "move_latas":
					this.lata1.move()
					this.lata2.move()
					this.lata3.move()
					setTimeout(() => {
						ObserverEmitter.emit(EVENTS.tema6.topic5.listenScene, "move_latas")
					}, 1000);
					break;
				case "insert_spin":
					this.camera.moveCameraToPoint(new Vector3(-10.504, -0.3049, 0.3529), 1, new Vector3(-10.795, -1.776, -0.363), () => {
						// this.camera.control.enableRotate = true;
						// this.camera.control.enablePan = true;
					});
					this.cards.position.set(-10.35, -0.93, 0.083)
					this.cards.rotation.set(-1.6, 0, 0)
					this.cards.scale.set(1.5, 1.5, 1.5)
					this.cards.Puntos.visible = false
					this.cards.Ticket.visible = false
					this.cards.visible = true
					this.cards.insertCard()
					setTimeout(() => {
						ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "monitor");
						ObserverEmitter.emit(EVENTS.tema6.topic5.listenScene, "insert_spin")
					}, 2000);
					break;
				case "monitor":
					this.lata1.remove()
					this.lata2.remove()
					this.lata3.remove()
					this.pinPad.visible = false
					this.keyboard.visible = false
					this.cards.visible = false
					this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
					});
					this.monitor.visible = true
					this.monitor.selectTexture(this.monitor.namesTextures.topic5_01)
					break;
				case "ticket":
					this.camera.moveCameraToPoint(new Vector3(-11.9553, -0.5964, -2.0764), 1, new Vector3(-11.04, -0.628, -1.673), () => {
						this.camera.control.minDistance = 0.6;
						this.camera.control.maxDistance = 2;
					});
					this.cards.Spin.visible = false
					this.cards.Puntos.visible = false
					this.cards.Ticket.visible = true
					this.cards.visible = true
					this.cards.scale.set(4, 4, 4)
					this.cards.position.set(-11, -1.8, -1.23)
					this.cards.rotation.set(0, -2, 0)
					break;
				case "finish":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {

					});
					this.cards.Spin.visible = true
					this.cards.Puntos.visible = true
					this.cards.Ticket.visible = true
					this.cards.visible = false
					break;
				default:
					this.resetActOne()
					break;
			}
		})
	}

	sceneActivityThreeState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema6.topic5.actScene, (step = "") => {
			switch (step) {
				case "desk":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {

					})
					this.cards.Spin.visible = true
					this.cards.Puntos.visible = true
					this.cards.Ticket.visible = true
					this.cards.visible = false
					break;
				case "show_products":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-11.97, -0.1378, 0.138), 1, new Vector3(-10.584, -1.579, 0.145), () => {
						// this.camera.control.enableRotate = true;
						// this.camera.control.enablePan = true;
					});
					this.pinPad.visible = true
					this.pinPad.position.set(-10.85, -0.97, 0.078)
					this.keyboard.visible = true
					this.keyboard.position.set(-11.3, -0.99, -0.8)
					this.lata1.visible = true
					this.lata1.position.set(-11.3, -0.92, 0.065)
					this.lata2.visible = true
					this.lata2.position.set(-11.3, -0.92, 0.335)
					this.lata3.visible = true
					this.lata3.position.set(-11.3, -0.81, 0.2)
					break;
				case "animate_latas":
					this.lata1.move()
					this.lata2.move()
					this.lata3.move()
					setTimeout(() => {
						ObserverEmitter.emit(EVENTS.tema6.topic5.listenScene, "animate_latas")
					}, 1000);
					break;
				case "spin":
					this.camera.moveCameraToPoint(new Vector3(-10.504, -0.3049, 0.3529), 1, new Vector3(-10.795, -1.776, -0.363), () => {
						// this.camera.control.enableRotate = true;
						// this.camera.control.enablePan = true;
					});
					this.cards.position.set(-10.35, -0.93, 0.083)
					this.cards.rotation.set(-1.6, 0, 0)
					this.cards.scale.set(1.5, 1.5, 1.5)
					this.cards.Puntos.visible = false
					this.cards.Ticket.visible = false
					this.cards.visible = true
					this.cards.insertCard()
					setTimeout(() => {
						ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "show_monitor");
						ObserverEmitter.emit(EVENTS.tema6.topic5.listenScene, "spin")
					}, 2000);
					break;
				case "show_monitor":
					this.lata1.remove()
					this.lata2.remove()
					this.lata3.remove()
					this.lata1.visible = false
					this.lata2.visible = false
					this.lata3.visible = false
					this.pinPad.visible = false
					this.keyboard.visible = false
					this.cards.visible = false
					this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
					});
					this.monitor.visible = true
					this.monitor.selectTexture(this.monitor.namesTextures.topic5_02)
					break;
				case "show_monitor_2":
					this.monitor.selectTexture(this.monitor.namesTextures.topic5_03)
					break;
				case "show_ticket":
					this.camera.moveCameraToPoint(new Vector3(-11.9553, -0.5964, -2.0764), 1, new Vector3(-11.04, -0.628, -1.673), () => {
						this.camera.control.minDistance = 0.6;
						this.camera.control.maxDistance = 2;
					});
					this.cards.Spin.visible = false
					this.cards.Puntos.visible = false
					this.cards.Ticket.visible = true
					this.cards.visible = true
					this.cards.scale.set(4, 4, 4)
					this.cards.position.set(-11, -1.8, -1.23)
					this.cards.rotation.set(0, -2, 0)
					break;
				default:
					this.resetActOne()
					break;
			}
		})
	}

	sceneActivityFourState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema6.topic5.actScene, (step = "") => {
			switch (step) {
				case "move_desk":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {

					})
					break;
				case "expand_desk":
					this.camera.moveCameraToPoint(new Vector3(-13.6326, 0.3982, -1.9179), 1, new Vector3(-11.493, -0.366, -1.905), () => {
						this.characterSelected.visible = false
					});
					break;
				case "client":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-7.0293, -0.1354, -0.8723), 1, new Vector3(-8.026, -0.213, -0.876), () => {

					});
					break;
				default:
					this.resetActOne()
					break;
			}
		})
	}

	listeners() {

	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 13.5;
					this.camera.control.maxDistance = 13.5;
					this.camera.control.enablePan = false;

					this.activeAudio()

				})
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.activeAudio()

					this.sceneActivityOneState();
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-11.9553, -0.5964, -2.0764), 1, new Vector3(-11.04, -0.628, -1.673), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.activeAudio()

					this.sceneActivityTwoState();
				});
				this.cards.Spin.visible = false
				this.cards.Ticket.visible = false
				this.cards.visible = true
				this.cards.position.set(-11, -1.25, -1.23)
				this.cards.rotation.set(0, -2, 0)
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.activeAudio()

					this.sceneActivityThreeState();
				});
				break;
			case 4:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.activeAudio()

					this.sceneActivityFourState();
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false
				});
				break;
		}
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				// const name = interactions[0].object.name;
				// ObserverEmitter.emit(EVENTS.tema3.listenClick, name);
			}
		});
	}

	renderAnimations(delta) {
	}
}
